export const base_path = '/';
export const img_path = '/react/template/';
